var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Status Badge Component
 * Displays shipment status with appropriate styling
 */
import React from 'react';
import { Tag } from 'antd';
import { ShipmentStatus } from '../types';
import { packingTagBadgeClassName } from './badgeStyles';
var getStatusColor = function (status) {
    switch (status) {
        case ShipmentStatus.Input:
            return 'default';
        case ShipmentStatus.Scheduled:
            return 'blue';
        case ShipmentStatus.Picked:
            return 'orange';
        case ShipmentStatus.Packed:
            return 'green';
        case ShipmentStatus.Shipped:
            return 'purple';
        case ShipmentStatus.Delivered:
            return 'cyan';
        case ShipmentStatus.Cancelled:
            return 'red';
        default:
            return 'default';
    }
};
export var StatusBadge = function (_a) {
    var status = _a.status, statusDescription = _a.statusDescription;
    var color = getStatusColor(status);
    return (_jsx(Tag, __assign({ color: color, className: packingTagBadgeClassName }, { children: statusDescription || status }), void 0));
};
export default StatusBadge;
